import * as React from 'react';
import { useHistory } from "react-router";
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { styled as styled_mui } from '@mui/material/styles';
import styled from "styled-components";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import cogoToast from "cogo-toast";

import ArrowForwardOutlined from "@material-ui/icons/ArrowForwardOutlined";
const BootstrapDialog = styled_mui(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function SavePrescreenPopup({ interviewPrescreenData, type, setInterviewPrescreenData, client_id, role_name, category_name, handleSavePrescreen }) {
  const [open, setOpen] = React.useState(false);
  const handleSave = () => {
    if(interviewPrescreenData?.questions?.length === 0 ){
      cogoToast.error('Please add prescreening test questions')
      return;
    }
     if(interviewPrescreenData?.questions?.length < (interviewPrescreenData?.number_of_questions || 0)){
      cogoToast.error(`Please add atleast ${interviewPrescreenData?.number_of_questions || 0} prescreening test questions`)
      return;
    }

    handleSavePrescreen(interviewPrescreenData, client_id, role_name, category_name);
  }

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <CustomContainer>
      <span variant="outlined" onClick={handleClickOpen}>
        Save Template <ArrowForwardOutlined className="ml-10" />
      </span>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle
          className="bold-600 fg-black font-18 font-style"
          id="customized-dialog-title"
          onClose={handleClose}
        >
          Save template
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <CustomBox>
            <Typography
              className="bold-400 font-14 fg-black font-style"
              gutterBottom
            >
             Are you sure you want to save this test template?
            </Typography>
          
            <Typography gutterBottom>
              <Button className="proceed_button_save_prescreen" onClick={handleSave}>Save</Button>
            </Typography>
          </CustomBox>
        </DialogContent>
      </BootstrapDialog>
    </CustomContainer>
  );
}

const CustomContainer = styled.div`
    display: inline-block;
    font-family: 'Poppins';
    letter-spacing: 0.005em;
`;

const CustomBox = styled.div`
    .proceed_button_save_prescreen {
    width: 180px;
    height: 40px;
    font-size: 14px;
    font-family: 'Poppins';
    font-weight: 600;
    letter-spacing: 0.005em;
    color: white;
    background-color: #123FBC;
    float: right;
    margin: 20px auto 10px auto;
}

.proceed_button_save_prescreen:hover{
  background-color: #123FBC;
  color: white;
}

.customInput {
    height: 46px;
    width: 450px;
    border: none;
    outline: none;
    border: 1px solid #C9C9C9;
    border-radius: 4px;
    padding-left: 8px;
    font-size: 14px;
    font-weight: 600;
    font-family: 'Poppins';
    letter-spacing: 0.005em;
    color: #3D3D3D;
    margin-top: 5px;
}

.customInput::placeholder {
    color: #A5A5A5;
}

.customError {
    font-size: 12px;
    font-weight: 400;
    font-family: 'Poppins';
    letter-spacing: 0.005em;
    color: #DC4F4F;
    margin-top: 5px;
}

.width-380 {
    width: 380px;
}

.font-style {
    font-family: 'Poppins';
    letter-spacing: 0.005em;
}

.fg-black {
    color: #3D3D3D;
}

.fg-gray {
    color: #ABABAB;
}

.bold-600 {
    font-weight: 600;
}

.bold-500 {
    font-weight: 500;
}

.bold-400 {
    font-weight: 400;
}

.font-18 {
    font-size: 18px;
}

.font-14 {
    font-size: 14px;
}

.font-12 {
    font-size: 12px;
}

`;